export default __webpack_public_path__ + "static/media/angle-double-left-solid.fde34b19.svg";